import React, { useState } from 'react';

import Dialog from '@mui/material/Dialog';
import { Close } from '@mui/icons-material';
import './Pops_Secials/WelcomeScreen/WelcomeScreen.css';
import myFunctions, { isMobileDevice } from '../myFunctions';
import ConnUrls from '../Connections/ConnectURL';

const PopUpPhoneCheckCode = (props) => {


    const [open, setOpen] = useState(true);
    const [inputTxt, setInputTxt] = useState("");
    const [err, setErr] = useState(props.showError ? true : false);
    const [erMsg, setErMsg] = useState(props.errorMsg);

    const CODE_LEN = 6;
    // במחשב - פוקוס ישר לקוביה הראשונה. בטלפון / טאבלט לא, כדי שהמקלדת לא תכסה את החלון
    const autoFocusCode = !isMobileDevice();
    const [focused, setFocused] = useState(autoFocusCode);
    const kbOpen = myFunctions.useKeyboardOpen();

    // שליחה אחת בכל פעם: מילוי אוטומטי + הקלדה, או "אימות" אחרי אימות אוטומטי, שלחו את
    // אותו קוד פעמיים - השנייה נכשלה (הקוד כבר נוצל) והחזירה את החלון מעל הודעת ההצלחה
    const busyRef = React.useRef(false);

    const saveMe = (val) => {
        const code = typeof val === "string" ? val : inputTxt;
        if (busyRef.current) return;
        if (code.length === CODE_LEN) {
            busyRef.current = true;
            Promise.resolve(props.okClick(code)).finally(() => { busyRef.current = false; });
        }
        else {
            setErr(true);
        }
    };

    // אנדרואיד (כרום): קריאת הקוד ישירות מה-SMS, אחרי אישור של המשתמש.
    // עובד רק כשהשורה האחרונה ב-SMS היא "@www.ashdodmenu.co.il #קוד" (SMSSender.SMS_Send)
    React.useEffect(() => {
        if (!('OTPCredential' in window) || !navigator.credentials) return;
        const ac = new AbortController();
        navigator.credentials.get({ otp: { transport: ['sms'] }, signal: ac.signal })
            .then((otp) => {
                const code = ((otp && otp.code) || "").replace(/\D/g, '').slice(0, CODE_LEN);
                if (code.length !== CODE_LEN) return;
                setInputTxt(code);
                setErr(false);
                saveMe(code);
            })
            .catch(() => { });
        return () => ac.abort();
    }, []);


    const handleClose = () => {
        if (typeof props.cancelClick === 'function') props.cancelClick();
    };

    myFunctions.useEscapeKey(handleClose);
    myFunctions.useBackClose(handleClose);

    const handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            saveMe();
        }
    };


    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);

    React.useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
            return () => clearInterval(interval);
        } else {
            setCanResend(true);
        }
    }, [timer]);

    const handleResendCode = () => {
        if (canResend) {
            props.recreateCode();
            setTimer(60);
            setCanResend(false);
        }
    };

    return (
        <Dialog open={open} className={`specialPopComp popDiagBlock ${props.cssStyl || ""}`}>
            <div className={`ws-card ws-dialogPad${kbOpen ? " ws-kb" : ""}`} dir="rtl">
                <div className="ws-header" dir="rtl">
                    <button type="button" className="btnReset ws-Close-btn onRight" aria-label="סגור" onClick={handleClose}>
                        <Close aria-hidden="true" style={{ width: '100%', height: '100%' }} />
                    </button>
                    <span className="arrowing fullRow ws-header-label">{props.topTitle ? props.topTitle : "התחברות"}</span>
                </div>

                <div className="ws-promo">
                    {props.topDodo &&
                        <div className="roundWrap">
                            <img src={ConnUrls.media(props.topDodo)} alt="" />
                        </div>
                    }
                    {(props.topSlides != null) ? props.topSlides : ""}
                    {props.topImg && <div className="imgblok" style={{ backgroundImage: `url(${props.topImg})` }}></div>}
                </div>

                <div className="bold ws-title arrowing">{props.Title.join(" ")}</div>
                <div className="ws-desc arrowing">
                    {props.ContentText.map((txtItm, index) => (
                        <span key={index}>{txtItm}<br /></span>
                    ))}
                </div>

                <label className="sr-only" htmlFor="wsCode">{props.placeholdTxtF || "קוד"}</label>
                {/* שדה אחד שקוף מעל הקוביות - הדבקה ומילוי אוטומטי מה-SMS עובדים כרגיל.
                    הקוביות תמיד משמאל לימין, גם במכשיר בעברית */}
                <div className={`ws-otp${err ? " ws-otp-err" : ""}`} dir="ltr">
                    {Array.from({ length: CODE_LEN }).map((_, i) => (
                        <div key={i} aria-hidden="true"
                            className={`ws-otp-box${inputTxt[i] ? " ws-otp-filled" : ""}${focused && i === Math.min(inputTxt.length, CODE_LEN - 1) ? " ws-otp-active" : ""}`}>
                            {inputTxt[i] || ""}
                        </div>
                    ))}
                    <input
                        id="wsCode"
                        className="ws-otp-input"
                        value={inputTxt}
                        onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, '').slice(0, CODE_LEN);
                            setInputTxt(val);
                            setErr(false);
                            if (val.length === CODE_LEN) saveMe(val);
                        }}
                        onKeyUp={handleKeyUp}
                        onFocus={(e) => { setFocused(true); myFunctions.scrollFieldIntoView(e); }}
                        onBlur={() => setFocused(false)}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        autoComplete="one-time-code"
                        maxLength={CODE_LEN}
                        dir="ltr"
                        aria-invalid={err}
                        aria-describedby="wsCodeErr"
                        autoFocus={autoFocusCode}
                    />
                </div>
                <div id="wsCodeErr" className="ws-err" role="alert">
                    {err ? ((inputTxt !== "" || !props.errorMsg) ? "יש להזין את כל 6 הספרות" : props.errorMsg) : ""}
                </div>

                <button type="button" className="ws-btn ws-btn-primary" onClick={saveMe}>אימות</button>

                <div className="ws-newUser">
                    {canResend ?
                        <>
                            לא קיבלתם את הקוד?{" "}
                            <button type="button" className="btnReset ws-link" onClick={handleResendCode}>צור קוד חדש</button>
                        </>
                        :
                        <span className="ws-muted">ניתן לבקש קוד חדש בעוד {timer} שניות</span>
                    }
                </div>
            </div>
        </Dialog >

    );
}

export default PopUpPhoneCheckCode;